const env = process.env;
const apiUrl = env.REACT_APP_API_URL || "https://7gybtv5xp5.execute-api.us-east-1.amazonaws.com";
const chatkitApiUrl = env.REACT_APP_CHATKIT_API_URL || "https://7gybtv5xp5.execute-api.us-east-1.amazonaws.com/chatkit";
const chatkitEnabled = env.REACT_APP_CHATKIT_ENABLED
  ? env.REACT_APP_CHATKIT_ENABLED !== 'false'
  : true;
const chatkitDomainKey = env.REACT_APP_CHATKIT_DOMAIN_KEY || "domain_pk_69aa3ea7997c8193b41713cfd81249c105a264c4fd070275";
const conversationAiToggleEnabled = env.REACT_APP_CONVERSATION_AI_TOGGLE_ENABLED
  ? env.REACT_APP_CONVERSATION_AI_TOGGLE_ENABLED !== 'false'
  : true;
const voiceOpsEnabled = env.REACT_APP_VOICE_OPS_ENABLED
  ? env.REACT_APP_VOICE_OPS_ENABLED !== 'false'
  : false;

const config = {
  appSync: {
    graphqlEndpoint: env.REACT_APP_APPSYNC_GRAPHQL_ENDPOINT || "https://sublr7icqjearlwykddtx7szji.appsync-api.us-east-1.amazonaws.com/graphql",
    apiKey: env.REACT_APP_APPSYNC_API_KEY || "da2-2zwsczxzgndgdeblw5wxp5z6ua",
    region: env.REACT_APP_AWS_REGION || "us-east-1"
  },
  apiUrl,
  chatkit: {
    enabled: chatkitEnabled,
    apiUrl: chatkitApiUrl,
    healthUrl: `${chatkitApiUrl}/health`,
    domainKey: chatkitDomainKey
  },
  features: {
    conversationAiToggleEnabled,
    voiceOpsEnabled
  },
  jwt: {
    expiresIn: 86400,
    tokenPrefix: "Bearer "
  }
};

export default config;
